import { takeLatest, call, put, all } from 'redux-saga/effects';

import { 
  fetchFavoriteFundsByAccountSuccess,
  fetchFavoriteFundsByAccountFailure,
  fetchNavFavoriteFundsByAccountSuccess,
  fetchNavFavoriteFundsByAccountFailure,
  updateLocalFavoriteFunds
} from '../_actions/favorite.actions';
import { favoriteConstants } from '../_constants';

import {
  addFavoriteFund,
  deleteFavoriteFund,
  putFavoriteFunds,
  fetchFavoriteFundsByAccount
} from '../_services/favorite.services';

import { 
	fetchNavForAdvanceSearch
} from '../_services/advance-search.services';

export function* addFavoriteFundAsync({ payload }) {
  try {
    let result = yield call(addFavoriteFund, payload);
    if (result.code.slice(0,3) === '200') {
      yield put(updateLocalFavoriteFunds({type: 'add', fundId: payload.fundId}));
    }
  } catch (error) {
  }
}

export function* deleteFavoriteFundAsync({ payload }) {
  try {
    let result = yield call(deleteFavoriteFund, payload);
    if (result?.code?.slice(0,3) === '200') {
      yield put(updateLocalFavoriteFunds({type: 'delete', fundId: payload.fundId}));
    }
  } catch (error) {
  }
}

export function* putFavoriteFundsAsync({ payload }) {
  try {
    yield call(putFavoriteFunds, payload);
  } catch (error) {
  }
}

export function* fetchFavoriteFundsByAccountAsync() {
  try {
    const result = yield call(fetchFavoriteFundsByAccount);
    yield put(fetchFavoriteFundsByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchFavoriteFundsByAccountFailure(error.message));
  }
}

export function* fetchNavFavoriteFundsByAccountAsync({ payload }) {
  try {
    const result = yield call(fetchNavForAdvanceSearch, payload);
    yield put(fetchNavFavoriteFundsByAccountSuccess(result.data));
  } catch (error) {
    yield put(fetchNavFavoriteFundsByAccountFailure(error.message));
  }
}

export function* addFavoriteFundStart() {
  yield takeLatest(favoriteConstants.ADD_FAVORITE_FUND, addFavoriteFundAsync);
}

export function* deleteFavoriteFundStart() {
  yield takeLatest(favoriteConstants.DELETE_FAVORITE_FUND, deleteFavoriteFundAsync);
}

export function* putFavoriteFundsStart() {
  yield takeLatest(favoriteConstants.PUT_FAVORITE_FUNDS, putFavoriteFundsAsync);
}

export function* fetchFavoriteFundsByAccountStart() {
  yield takeLatest(favoriteConstants.FETCH_FAVORITE_FUNDS_BY_ACCOUNT_START, fetchFavoriteFundsByAccountAsync);
}

export function* fetchNavFavoriteFundsByAccountStart() {
  yield takeLatest(favoriteConstants.FETCH_NAV_FAVORITE_FUNDS_BY_ACCOUNT_START, fetchNavFavoriteFundsByAccountAsync);
}

export function* favoriteSagas() {
  yield all([
    call(addFavoriteFundStart),
    call(deleteFavoriteFundStart),
    call(putFavoriteFundsStart),
    call(fetchFavoriteFundsByAccountStart),
    call(fetchNavFavoriteFundsByAccountStart)
  ]);
}
